import React, { useState } from "react";
import axios from "axios";
import { Crosshair } from "lucide-react";
import { toast } from "sonner";

const client = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api/mesh-lights` });
client.interceptors.request.use((cfg) => { const t = localStorage.getItem("admin_token"); if (t) cfg.headers.Authorization = `Bearer ${t}`; return cfg; });

const NUMS = Array.from({ length: 16 }, (_, i) => i + 1);

export const GroupFinder = ({ c, onChanged }) => {
  const [n, setN] = useState(null);
  const [busy, setBusy] = useState(false);
  const probe = async (k) => {
    setBusy(true); setN(k);
    try { await client.post(`/controllers/${c.id}/probe-group/${k}`); toast.info(`Tutto spento, acceso solo il gruppo n. ${k}: guarda quali luci si accendono`); }
    catch { toast.error("Comando non inviato"); } finally { setBusy(false); }
  };
  const assign = async (gid) => {
    try { await client.put(`/controllers/${c.id}/groups/${gid}/app-group`, { n }); toast.success(`"${c.groups.find((g) => g.id === gid)?.name}" ora comanda il gruppo n. ${n}`); onChanged(); }
    catch (e) { toast.error(e?.response?.data?.detail || "Errore"); }
  };
  return (
    <details className="rounded-2xl border border-[#e8dcc8] bg-white p-3 text-xs" data-testid="group-finder">
      <summary className="cursor-pointer font-semibold text-[#4a1c17] inline-flex items-center gap-1"><Crosshair className="h-3.5 w-3.5" /> Un gruppo non risponde? Trova il suo numero nell'app BRmesh</summary>
      <p className="mt-2 text-[#7c5a4e]">L'app BRmesh dà a ogni gruppo un numero (1–16) che non sempre segue l'ordine. Premi un numero: tutto si spegne e si accende solo quel gruppo. Quando vedi accendersi le luci giuste, collega il numero al gruppo.</p>
      <div className="mt-2 flex flex-wrap gap-1.5">
        {NUMS.map((k) => <button key={k} disabled={busy} onClick={() => probe(k)} className={`h-8 w-9 rounded-md border text-xs font-semibold ${n === k ? "bg-[#4a1c17] text-white border-[#4a1c17]" : "bg-white text-[#4a1c17] border-[#e8dcc8]"}`} data-testid={`group-probe-${k}`}>{k}</button>)}
      </div>
      {n && (
        <div className="mt-3 flex flex-wrap items-center gap-1.5">
          <span className="text-[#7c5a4e] mr-1">Il n. {n} è:</span>
          {c.groups.map((g) => <button key={g.id} onClick={() => assign(g.id)} className={`h-8 px-2.5 rounded-full border text-xs font-semibold ${g.app_group_id === n ? "bg-emerald-600 text-white border-emerald-600" : "bg-white text-[#4a1c17] border-[#e8dcc8]"}`} data-testid={`group-assign-${g.id}`}>{g.name}{g.app_group_id ? ` (${g.app_group_id})` : ""}</button>)}
        </div>
      )}
    </details>
  );
};
